import React from 'react';
import { SelectInput, TextInput, required } from 'react-admin';
import { Grid } from '@material-ui/core/';
import { Field } from 'react-final-form';
import CheckBoxField from '../../core/components/CheckBoxField';
import { categoryStatus } from './CategoryLookups';
import { fieldLengthValidator } from '../../core/utils/index';

const SubcategorySummary = () => (
  <div>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <TextInput
          source="name"
          label="Subcategory Name"
          validate={[required(), fieldLengthValidator(128)]}
          variant="standard"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginRight: '2px' }}>
        <TextInput
          multiline
          source="description"
          label="Subcategory Description"
          rows="3"
          variant="standard"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <SelectInput
          source="status"
          label="Subcategory Status"
          choices={categoryStatus}
          validate={[required()]}
          variant="standard"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Field
          name="excludeFromDailySummary"
          component={CheckBoxField}
          label="Exclude From Daily Summary Email"
          variant="standard"
          type="checkbox"
        />
      </Grid>
    </Grid>
  </div>
);

export default SubcategorySummary;
